import {useEffect, useState} from "react";

export const useInterSectionObserver = (onIntersect, option) => {
  const [target, setTarget] = useState(null);

  const checkIntersect = ([entry]) => {
    if (entry.isIntersecting) {
      onIntersect();
    }
  };

  useEffect(() => {
    let observer;
    if (target) {
      observer = new IntersectionObserver(checkIntersect, option);
      observer.observe(target);
    }
    return () => observer && observer.disconnect();
  }, [target, option?.root, option?.threshold, option?.rootMargin, checkIntersect]);

  return [target, setTarget];
};
